import React from 'react';
import { TaxAddressModal } from './TaxAddressModal';
import { TaxAddressField, TaxBehaviorSelector, TaxRegistrations, TaxToggleHeader, useTaxSectionState } from './tax';

export const TaxSection: React.FC = () => {
    const {
        isStripeConnected,
        taxSettingsLoading,
        updateLoading,
        chargeStripeTax,
        taxBehavior,
        taxAddress,
        taxAddressString,
        hasTaxIssue,
        activeRegistrationTags,
        isAddressModalOpen,
        openAddressModal,
        handleTaxToggle,
        handleTaxBehaviorChange,
        handleAddressUpdate,
        handleAddressModalClose,
    } = useTaxSectionState();

    // Don't render if Stripe is not connected or taxes not allowed
    if (!isStripeConnected || taxSettingsLoading) {
        return null;
    }

    return (
        <>
            <div className='rounded-lg'>
                <TaxToggleHeader
                    enabled={chargeStripeTax}
                    loading={updateLoading}
                    hasTaxIssue={hasTaxIssue}
                    onToggle={handleTaxToggle}
                />

                {chargeStripeTax && (
                    <div className='space-y-6'>
                        <TaxBehaviorSelector
                            behavior={taxBehavior}
                            loading={updateLoading}
                            onBehaviorChange={handleTaxBehaviorChange}
                        />

                        <TaxAddressField
                            addressString={taxAddressString}
                            loading={updateLoading}
                            onEdit={openAddressModal}
                        />

                        <TaxRegistrations tags={activeRegistrationTags} />
                    </div>
                )}
            </div>

            <TaxAddressModal
                isOpen={isAddressModalOpen}
                onClose={handleAddressModalClose}
                onSubmit={handleAddressUpdate}
                initialAddress={taxAddress}
                loading={updateLoading}
            />
        </>
    );
};
